import Utils from './utils';

export default class Screen {

	constructor(args) {
		this.system = args.system;
		this.elem = args.elem; // container DOM element where PIXI will create its <canvas>
		this.minWidth = args.minWidth;
		this.maxWidth = args.maxWidth;
		this.minHeight = args.minHeight;
		this.maxHeight = args.maxHeight;
		this.preScale = args.preScale; // exaggerate available viewport to force higher density
		this.width = this.minWidth;
		this.height = this.minHeight;
		this.canvasWidth = this.width;
		this.canvasHeight = this.height;
		this.elemWidth = 0;
		this.elemHeight = 0;
		this.scaleFactor = 1; // root PIXI stage object to be scaled to fill the canvas, meaning game code can use predictable absolute units regardless of viewport dimensions
		// this.density = window.devicePixelRatio;
		this.density = 1;
		
		this.focused = true;
		this.resizeCallback = null;

		window.addEventListener('blur', this.onBlur.bind(this));
		window.addEventListener('focus', this.onFocus.bind(this));
		window.addEventListener('resize', this.onResize.bind(this));

		this.maximise();
		this.setScale();
	}

	// set new width/height based on min/max limits and current browser/window size
	maximise() {
		let vw = window.innerWidth;
		let vh = window.innerHeight;
		if(document.fullscreenElement) {
			if(window.screen) {
				vw = window.screen.width;
				vh = window.screen.height;
			} else {
				vw = document.body.clientWidth;
				vh = document.body.clientHeight;
			}
		}
		vw *= this.preScale;
		vh *= this.preScale;
		if(vw < this.minWidth) {
			// allow heights larger than actual screen height
			// when entire viewport will be scaled down anyway
			vh *= this.minWidth/vw;
		}
		this.width = ~~Utils.clamp(vw, this.minWidth, this.maxWidth);
		this.height = ~~Utils.clamp(vh, this.minHeight, this.maxHeight);
	}

	// adjust
	onResize(e) {
		this.setScale();
		if(this.resizeCallback) this.resizeCallback(e);
	}

	onBlur() {
		if(this.system.debug) console.log('%capp unfocused', 'color:#cc5500');
		this.focused = false;
		this.system.audio.suspendAll();
	}
	
	onFocus() {
		if(this.system.debug) console.log('%capp focused', 'color:#00cc55');
		this.focused = true;
		this.system.audio.resumeAll();
	}

	/**
	 * Convert screenspace canvas offset coords to internal display coords
	 */
	getCoords(x, y) {
		let mult = this.width / this.system.display.renderer.view.clientWidth;
		return { x:x*mult, y:y*mult };
	}

	setScale() {
		this.canvasWidth = this.width;
		this.canvasHeight = this.height;
		this.scaleFactor = this.canvasWidth / this.width; // remnant from fill scaling support, will always be 1.0, currently
		if(this.system.display) {
			this.system.display.resize(this.canvasWidth, this.canvasHeight, this.scaleFactor);
		}
	}

}